const { createContext } = require("react");

const AppContext = createContext();
export default AppContext;
